"use strict";
import 'normalize.css';
import '/src/css/style.scss';

import { init as initPlausible } from '@plausible-analytics/tracker';
// Cookieless, no personal data - not gated behind cookie consent. Auto-tracks
// Swup's pushState navigations, so no manual pageview calls are needed.
// Domain comes from window.PLAUSIBLE_DOMAIN (set server-side in base.html) rather
// than a Vite build-time env var, since the same built bundle is deployed to every
// environment - only a value read per-request can tell staging apart from production.
if (window.PLAUSIBLE_DOMAIN) {
  initPlausible({ domain: window.PLAUSIBLE_DOMAIN });
}

import Navigation from './modules/Navigation';
import BgGradientGL from './modules/BgGradientGL';
import LogoAnimation from './modules/LogoAnimation';
import HomepageCarousel from './modules/HomepageCarousel';
import Slideshow from './modules/Slideshow';
import Infinite from './modules/Infinite';
import BridgesCarousel from './modules/BridgesCarousel';
import BridgesGraphic from './modules/BridgesGraphic';
import ConsentManager from './modules/CookieConsent';
import PageTransitions from './modules/PageTransitions';


// Global modules — instantiated once, persist across all navigations
new BgGradientGL(document.querySelector('.js-bg-gradient'));
new BgGradientGL(document.querySelector('.js-bg-gradient-signup'), { accentColour: false });
const navigation = new Navigation();
new LogoAnimation();
new ConsentManager();

(function() {
  document.documentElement.className =
    document.documentElement.className.replace(/\bno-js\b/g, "") + " js ";
})();

// Track Infinite instances for cleanup between navigations.
// The site is expected to have at most one .js-infinitescroll per page.
// If multiple exist, they are all tracked and destroyed correctly here,
// but note that Infinite.js uses document.querySelector('.js-loadmore')
// (not scoped to the container), so multiple simultaneous instances would
// share the same loadmore button — a pre-existing limitation.
let infiniteInstances = [];

function initPageModules() {
  // Destroy previous Infinite instances to remove window scroll listeners
  infiniteInstances.forEach(i => i.destroy());
  infiniteInstances = [];

  const carouselModules = document.querySelectorAll('.js-carousel');
  if (carouselModules) { carouselModules.forEach(el => new HomepageCarousel(el)); }

  const slideshowModules = document.querySelectorAll('.js-slideshow');
  if (slideshowModules) { slideshowModules.forEach(el => new Slideshow(el)); }

  const bridgesCarouselModules = document.querySelectorAll('.js-bridges-carousel');
  if (bridgesCarouselModules) { bridgesCarouselModules.forEach(el => new BridgesCarousel(el)); }

  const bridgesGraphicModules = document.querySelectorAll('.js-river-map');
  if (bridgesGraphicModules) { bridgesGraphicModules.forEach(el => new BridgesGraphic(el)); }

  const infiniteScrollModules = document.querySelectorAll('.js-infinitescroll');
  infiniteScrollModules.forEach(el => {
    infiniteInstances.push(new Infinite(el));
  });
}

document.addEventListener("DOMContentLoaded", function(){
  document.addEventListener("touchstart", function () {}, true);
});

// Initial page load
initPageModules();

// Page transitions — reinitialises page modules after each Swup swap
new PageTransitions(() => {
  initPageModules();
  requestAnimationFrame(() => navigation.scrollNavToActive());
});
